
import PersonnelStats from './PersonnelStats/PersonnelStats.vue'
import ObservationStat from '@/views/Project/Dashboard/components/observationStatistics.vue'

import UserMixin from '@/_mixins/user'
import { setObservationStatisticsFilters } from '@/types/observation'

type WidgetId = 'personnel-stats' | 'observation-stat'

export default {
    name: 'ContractorInsights',
    mixins: [UserMixin],
    components: {
        ObservationStat,
        PersonnelStats,
    },
    props: {
        contractorId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            inViewport: false,
            observer: null as IntersectionObserver | null,
        }
    },
    computed: {
        widgets() {
            return [this.newWidget('personnel-stats'), this.newWidget('observation-stat')]
        },
        id() {
            return `p${this.currentProjectId}-${this.contractorId}`
        },
    },
    methods: {
        newWidget(id: WidgetId) {
            let component: any = null
            let name: any = ''

            let settings = this.getWidgetSettings(id)

            switch (id) {
                case 'personnel-stats':
                    component = PersonnelStats
                    name = this.$t('dashboard.personnelstatswidget')
                    break
                case 'observation-stat':
                    component = ObservationStat
                    name = this.$t('fe_dashboard_module.observation_module_title')
                    if (!settings) {
                        settings = setObservationStatisticsFilters({
                            contractors: this.$route.params.companyId,
                            project: this.currentProjectId,
                        })
                    }
                    break
                default:
                    break
            }

            return {
                component,
                componentAttrs: {
                    id,
                    name: settings?.title || name,
                    settings,
                },
            }
        },
        getWidgetSettings(id: string) {
            const settings =
                this.$store.getters.frontEndSettings?.contractors?.[this.id]?.widgetData?.[id]

            if (settings) {
                return JSON.parse(JSON.stringify(settings))
            }

            return null
        },
        saveSettings(id: string, settings: any) {
            let { contractors } = this.$store.getters.frontEndSettings

            this.$store.commit('frontEndSettings', {
                ...(this.$store.getters.frontEndSettings && {
                    ...this.$store.getters.frontEndSettings,
                }),
                contractors: {
                    ...contractors,
                    [this.id]: {
                        ...contractors[this.id],
                        widgetData: {
                            ...contractors[this.id]?.widgetData,
                            [id]: { ...settings },
                        },
                    },
                },
            })

            this.patchUser({
                data: {
                    id: this.currentUser.id,
                    type: 'user',
                    attributes: {
                        frontEndSettings: JSON.stringify(this.$store.getters.frontEndSettings),
                    },
                },
            })
        },
    },
    mounted() {
        const target = document.querySelector('#contractor-insights') as HTMLElement
        this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    this.inViewport = true
                    this.observer?.unobserve(target)
                    break
                }
            }
        })
        this.observer.observe(target)
    },
    beforeDestroy() {
        this.observer?.disconnect()
    },
}
